export interface UserPermission {
  resource: string;
  action: string;
  partnerId?: string | null;
}

type PermissionAction = 'read' | 'create' | 'update' | 'delete';

export const canPerform = (
  permissions: UserPermission[],
  resource: string,
  action: PermissionAction,
  partnerId?: string | null,
): boolean =>
  permissions.some((permission) => {
    const resourceMatches = permission.resource === resource || permission.resource === '*';
    const actionMatches = permission.action === action || permission.action === '*';
    const scopeMatches =
      permission.partnerId === null || (permission.partnerId !== undefined && permission.partnerId === partnerId);

    return resourceMatches && actionMatches && scopeMatches;
  });
